import { useState } from 'react';
import { TermsAndPolicies } from '../types';
import { useApi } from '../api/useApi';
import { useTermsAndPoliciesState } from '../../redux/reducers/termsAndPoliciesReducer';
import { useTermsAndPoliciesActions } from '../../redux/actions/termsAndPoliciesActions';

export const TermsAndPoliciesRoutes = {
    getTerms: () => 'tcw/terms',
};

export const useTermsAndPoliciesService = () => {
    const termsState = useTermsAndPoliciesState();
    const termsActions = useTermsAndPoliciesActions();
    const [loadingTerms, setLoadingTerms] = useState(false);
    const accountApi = useApi<TermsAndPolicies>('api/Account');

    const loadTermsAsync = async () => {
        setLoadingTerms(true);
        try {
            const termsAndPolicies = await accountApi.getAsync(TermsAndPoliciesRoutes.getTerms());
            termsActions.setTermsAndPolicies(termsAndPolicies);
        } finally {
            setLoadingTerms(false);
        }
    };

    return { termsAndPolicies: termsState.termsAndPolicies, loadingTerms, loadTermsAsync };
};
